export class Constants {
  static SSO_PROVIDER_DISPLAY_MAP: Record<string, string> = { azureadidp: ' Azure SSO' };
  static ERROR_MSG_SERVICE_UNAVALIABLE = 'Service unavailable, please try again in a few minutes.';
}
